import { Container, Grid, Typography, Button } from "@pmberjaya/cloudbank-ui";
import { useRouter } from "next/router";
import React, { useEffect } from "react";

const HeaderPartner = (props) => {
  const { title, description, button } = props;
  const router = useRouter();
  const handleClick = () => {
    if (button === "reseller") {
      var elem = document.getElementById("resellerMobile");
      elem.scrollIntoView(true);
      document.getElementById("resellerDesktop").scrollIntoView();
    } else if (button === "afiliasi") {
      document.getElementById("afiliasiDesktop").scrollIntoView();
      document.getElementById("afiliasiMobile").scrollIntoView();
    }
  };
  const handleClickRedirect = () => {
    if (button === "reseller") {
      window.open(`https://reseller.cloudbank.id`);
    } else if (button === "afiliasi") {
      window.open(`https://affiliation.cloudbank.id`);
    }
  };

  return (
    <div className="bg-primary  pb-5 header-height">
      <Container>
        <Grid
          row
          className="full-height"
          justifyContent="center"
          alignItems="center"
          alignSelf="center"
        >
          <Grid md={8} className="margin-header-top">
            <Typography variant="h1" className="text-heading" color="light">
              {title}
            </Typography>
            <Typography
              className="text-paragraf"
              color="light"
              fontWeight="bolder"
            >
              {description}
            </Typography>
            <div className="mt-5 d-flex">
              <Button
                color="light"
                // onTouchStart={handleClick}
                onClick={handleClick}
                variant="outlined"
                size="large"
                className="justify-content-center "
              >
                Daftar Sekarang
              </Button>
              <Button
                color="light"
                onClick={handleClickRedirect}
                variant="contained"
                size="large"
                className="justify-content-center ms-3"
              >
                Login {button === "reseller" ? "Reseller" : "Afiliasi"}
              </Button>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default HeaderPartner;
